<template>
  <div class="v2-auto-control">
    <div class="auto-control-title">
      <p>{{activeTitle}}</p>
      <!-- <p>
        <span>报警电话：</span>
        <span>{{alarmPhone}}</span>
      </p> -->
    </div>
    <div class="auto-control-content">
      <ul>
        <li v-for="(item,index) in dataList" :key="index">
          <div class="parameter-name">
            <div class="img">
              <img src="../../assets/images/sprite/icon_fengxiang.png" alt="" v-if="item.sensorName=='风向'">
              <img src="../../assets/images/sprite/icon_fengsu.png" alt="" v-if="item.sensorName=='风速'">
              <img src="../../assets/images/sprite/icon_NH3.png" alt="" v-if="item.sensorName=='氨气'">
              <img src="../../assets/images/icon_temperature.png" alt="" v-if="item.sensorName=='水温'">
              <img src="../../assets/images/icon_rongjieyang.png" alt="" v-if="item.sensorName=='溶解氧'">
              <img src="../../assets/images/icon_yanghuadianhuanyuan.png" alt="" v-if="item.sensorName=='氧化电还原'">
              <img src="../../assets/images/icon_ph.png" alt="" v-if="item.sensorName=='PH值'">
              <img src="../../assets/images/icon_yanbaohedu.png" alt="" v-if="item.sensorName=='氧饱和度'">
              <img src="../../assets/images/icon_daqiya.png" alt="" v-if="item.sensorName=='大气压'">
              <img src="../../assets/images/icon_shidu.png" alt="" v-if="item.sensorName=='湿度' || item.sensorName=='土壤湿度'">
              <img src="../../assets/images/icon_guangzhao.png" alt="" v-if="item.sensorName=='光照'">
              <img src="../../assets/images/icon_co2.png" alt="" v-if="item.sensorName=='二氧化碳'">
              <img src="../../assets/images/icon_temperature.png" alt="" v-if="item.sensorName=='温度' || item.sensorName=='土壤温度'">
            </div>
            <div class="concact-data">
              <p class="name">{{item.sensorName}}</p>
              <p class="data">
                <span>{{item.currentValue}}</span>
                <span>{{item.unitTitle}}</span>
              </p>
            </div>
            <!-- <div class="correct" v-if="item.sensorName=='溶解氧'"  style="opacity:0">
              <el-button type="primary" @click="correct()">校准</el-button>
            </div>
            <div class="correct" v-else style="opacity:0">
              <el-button type="primary" @click="correct()"></el-button>
            </div> -->
          </div>
          <div class="parameter-form">
            <p>
              <span class="label-name">下&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;限：</span>
              <el-input class="limit" v-model="item.lowerLimit" placeholder="" >
                <i slot="suffix" class="el-input__icon" >{{item.unitTitle}}</i>
              </el-input>
              <el-switch
                v-model="item.lowerLimitHandle"
                inactive-color="rgba(93,106,118,0.4)"
                @change="changeSwitch(item)"
              >
              </el-switch>
            </p>
            <p>
              <span class="label-name">上&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;限：</span>
              <el-input class="limit" v-model="item.upperLimit" placeholder="" >
                <i slot="suffix" class="el-input__icon" >{{item.unitTitle}}</i>
              </el-input>
              <el-switch
                v-model="item.upperLimitHandle"
                inactive-color="rgba(93,106,118,0.4)"
              >
              </el-switch>
            </p>
            <p>
              <span class="label-name">远程控制:</span>
              <el-select
                v-model="item.switchEquipmentId"
                slot="prepend"
                clearable
                placeholder="请选择设备"
                @change="selectEquement(item,index)"
                @clear="clear(item)"
              >
                <el-option
                  v-for="(item,index) in sensors"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </p>
            <div v-if="item.isClear">
              <p class="choose-line" v-if="list[index] && list[index].switchs && list[index].switchs.length!==0">选择线路</p>
              <div class="checkbox-group" v-if="list[index] && list[index].switchs && list[index].switchs.length!==0">
                <el-checkbox-group v-model="item.switchSocketIds" @change='changeSwitchs'>
                  <el-checkbox v-for="(item,index) in list[index].switchs" :label="item.id" :key="index">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

          </div>
        </li>
      </ul>
      <div class="auto-control-btn">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import equipmentV2 from '../../store/modules/equipmentV2'
import autoControl from '../../store/modules/autoControl'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'autoControl',
  data () {
    return {
      alarmPhone: '',
      name: '',
      equId: '',
      sensors: [],
      checkedRtu: [],
      switchSocketIds: [], // 选中线路[0,1,2]
      switchs: [],
      dataList: [],
      upSwitch: false,
      downSwitch: false,
      isClears: true,
      list: [
        {
          switchs: []
        },
        {
          switchs: []
        },
        {
          switchs: []
        },
        {
          switchs: []
        },
        {
          switchs: []
        }
      ]
    }
  },
  watch: {
    equipmentData (data) {
      this.init()
    }

  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState(equipmentV2, ['equipmentData', 'activeTitle'])
  },
  methods: {
    ...mapMutations(equipmentV2, ['setActiveTitle']),
    ...mapActions(autoControl, ['getlimitControlData', 'updatelimitControlData']),
    // 清空远程控制设备
    clear (val) {
      // val.sensorSocketId = null
      val.switchSocketIds = []
    },
    // 保存
    save () {
      this.updatelimitControlData(this.dataList).then((rsp) => {
        this.$Alert.info({
          content: '保存成功',
          duration: 1000,
          status: 'success'
        })
        setTimeout(() => {
          this.$router.push({
            name: 'equipmentControl'
          })
        }, 500)
      }).catch((err) => {
        console.log(err)
        this.$Alert.info({
          content: err.response.data,
          duration: 3000,
          status: 'error'
        })
      })
    },
    init () {
      this.setActiveTitle('自动控制')
      this.sensors = this.equipmentData.switchEquipments
      this.getlimitControlData(this.$route.query.equId).then((rsp) => {
        if (rsp.alarmPhone.length === 2) {
          this.alarmPhone = rsp.alarmPhone[0] + ',' + rsp.alarmPhone[1]
        } else {
          this.alarmPhone = rsp.alarmPhone[0]
        }
        let data = rsp.swithLimits
        this.dataList = data
        this.dataList.forEach((data, index) => {
          data.isClear = true
          this.isClears = data.isClear
          if (data.switchEquipmentId) {
            this.selectEquement(data, index, '1')
          }
          if (data.lowerLimitHandle === 0) {
            data.lowerLimitHandle = false
          } if (data.lowerLimitHandle === 1) {
            data.lowerLimitHandle = true
          }
          if (data.upperLimitHandle === 0) {
            data.upperLimitHandle = false
          } if (data.upperLimitHandle === 1) {
            data.upperLimitHandle = true
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },

    // 切换远程控制获取开关
    selectEquement (item, index, a) {
      if (a !== '1') {
        this.clear(item, index)
      }
      if (item.switchEquipmentId === '') {
        this.list[index].switchs = []
        return
      }
      if (this.sensors.length === 0) {
        return
      }
      this.sensors.find((f) => {
        if (f.id === item.switchEquipmentId) {
          this.list[index].switchs = f.switchs
          this.isClears = true
          return this.list[index].switchs
        }
      })
    },
    changeSwitchs (val) {
      console.log(1111, val)

      this.switchSocketIds = val
    },
    // 校准
    correct () {

    },
    changeSwitch () {},
    // 取消
    cancel () {
      this.$router.push({
        name: 'equipmentControl'
      })
    }

  }

}
</script>
<style lang="scss">
.v2-auto-control{
  width: 100%;
  padding-bottom: 20px;
  overflow: auto;
  height: calc(100vh - 65px);
  .auto-control-title{
    display: flex;
    justify-content:space-between;
    font-size:20px;
    margin-top:20px;
    font-family:Microsoft YaHei;
    color:rgba(254,254,254,1);
    p:first-child{
      margin-left:72px;
    }
    p:last-child{
      margin-right:100px;
    }
  }

}

  .auto-control-content{
    ul{
      display: flex;
      flex-wrap:wrap;
      li{
        width:392px;
        height:602px;
        background: url('../../assets/images/zidongkongzhi__kuang.png') no-repeat;
        background-size:100% 100%;
        margin-left:66px;
        margin-top:30px;
      }
      .parameter-name{
        display: flex;
        justify-content: flex-start;
        margin-top:33px;
        margin-left:28px;
        font-family:Microsoft YaHei;
        .concact-data{
          margin-left:20px;
          .name{
            font-size:22px;
            color:rgba(0,198,255,1);
          }
          .data{
            span:first-child{
              font-size:44px;
              color:rgba(0,213,60,1);
            }
            span:last-child{
              // padding-left:10px;
              font-size:18px;
              color:#FFFFFF;
            }
          }
        }
        .correct{
          margin-left:35px;
          margin-right:32px;
          .el-button{
            margin-top:50px;
            width:72px;
            height:32px;
            padding: 10px 0px !important;
            background:rgba(0,119,255,1);
            border:1px solid rgba(48, 145, 255, 1);
            border-radius:4px;
          }
        }

      }
      .parameter-form{
        p{
          margin-left:38px;
          margin-top:30px;
        }
        .label-name{
          font-size:15px;
        }
        .el-input {
          width: 232px;
          margin-left: 12px;
        }
        .limit{
          width: 148px;
        }
        .el-input__inner {
          border: 1px solid #07f;
          color:rgba(255,255,255,1);
          background: none;
          font-size:18px;
          font-family:Microsoft YaHei;
        }
        .el-select{
          width: 232px;
          color:rgba(255,255,255,1);
          margin-left: 12px;
        }
        .el-input__icon {
          height: 100%;
          width: 36px;
          text-align: center;
          -webkit-transition: all .3s;
          transition: all .3s;
          line-height: 40px;
        }
        .el-switch{
          margin-left:20px;
        }
        .el-switch,
          .el-switch__core {
            width: 66px !important;
            height: 34px;
            border-radius: 20px;
          }
          .el-switch__core:after {
            width: 30px;
            height: 30px;
            background-color: #fff;
          }
          .el-switch.is-checked .el-switch__core::after {
            left: 100%;
            margin-left: -28px;
          }
      }
      .choose-line{
        margin-top:60px!important;
        font-size:16px;
        font-family:Microsoft YaHei;
        color:rgba(139,145,159,1);
      }
      .checkbox-group{
        margin-left:38px;

        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: none!important;
          border-color: #409EFF;
        }
        .el-checkbox:nth-child(3){
          margin-left:0px;
        }
        .el-checkbox{
          margin-top:40px;
          max-width:140px;
          width:140px;
          border:1px silid red;
          // overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;

        }
        .el-checkbox__label {
          display: inline-block;
          text-align: center;
          padding-left: 16px;
          font-size:18px;
          font-family:Microsoft YaHei;
          color:rgba(255,255,255,1);
          vertical-align: text-bottom;
        }
        .el-checkbox__inner{
          background: none;
          border-color: #3091FF;
          width:22px;
          height:22px;
        }
        .el-checkbox__inner::after {
          -webkit-box-sizing: content-box;
          box-sizing: content-box;
          content: "";
          border: 2px solid #3091FF;
          border-left: 0;
          border-top: 0;
          height: 11px;
          left: 7px;
          position: absolute;
          top: 2px;
          width: 5px;
       }

      }
    }
  }
  .auto-control-btn{
    display: flex;
    justify-content:center;
    padding-top:54px;
    .el-button{
      width:160px;
      // height:40px;
      font-size:20px;
      font-family:Microsoft YaHei;
      padding: 10px 0px !important;
      border-radius:4px;
    }
    .el-button--default{
      border:1px solid #0077FF;
      color: #BBD4E9;
      background:rgba(30,63,117,0);
    }
    .el-button--primary {
      margin-left: 30px;
      color:rgba(255,255,255,1);
      background:rgba(0,119,255,1);
      border:1px solid rgba(48, 145, 255, 1);
    }
  }
</style>
